import { Box } from '@mui/material'

export default function BottomSpacer() {
  return <Box sx={{ height: '50px', width: '100%' }} />
}
